export default __webpack_public_path__ + "static/media/1847.9dcc1a20.png";